import SubHeader from "@/components/SubHeader";
import LottieAnimation from "@/components/Lottie";
import { isFilled } from "@prismicio/client";
import { PrismicRichText } from "@prismicio/react";

/**
 * @typedef {import("@prismicio/client").Content.ProjectHighLightSlice} ProjectHighLightSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<ProjectHighLightSlice>} ProjectHighLightProps
 * @type {import("react").FC<ProjectHighLightProps>}
 */
const ProjectHighLight = ({ slice }) => {
  const { sub_header, title, text, lottie_url } = slice.primary;
  const lottieSrc = isFilled.link(lottie_url) ? lottie_url.url : undefined;

  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
    >
      <div className="flex flex-col items-center justify-center gap-8 rounded-[20px] bg-beige-50 p-[30px] md:flex-row gap-[50px]">
        {lottieSrc && (
          <div className="h-[155px] w-[155px]">
            <LottieAnimation src={lottieSrc} className="h-full w-full" />
          </div>
        )}

        <div className="flex flex-1 flex-col gap-4">
          {isFilled.keyText(sub_header) && <SubHeader text={sub_header} />}

          {(isFilled.richText(title) || isFilled.richText(text)) && (
            <div className="flex w-full flex-col gap-2 text-bleu">
              {isFilled.richText(title) && (
                <PrismicRichText
                  field={title}
                  components={{
                    heading2: ({ children }) => (
                      <h2 className="p-xl font-medium">{children}</h2>
                    ),
                    heading3: ({ children }) => (
                      <h3 className="p-xl font-medium">{children}</h3>
                    ),
                  }}
                />
              )}

              {isFilled.richText(text) && (
                <PrismicRichText
                  field={text}
                  components={{
                    paragraph: ({ children }) => (
                      <p className="p-lg text-bleu">{children}</p>
                    ),
                    strong: ({ children }) => (
                      <strong className="font-semibold">{children}</strong>
                    ),
                    em: ({ children }) => <em className="italic">{children}</em>,
                    hyperlink: ({ children, node }) => (
                      <a
                        href={node.data.url}
                        className="text-bleu underline underline-offset-2"
                      >
                        {children}
                      </a>
                    ),
                  }}
                />
              )}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default ProjectHighLight;
